import {
  Autocomplete,
  Box,
  Button,
  Fade,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Select,
  Switch,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import React, { useEffect, useState } from "react";

import TotalChart from "../TotalChart";
import useDeviceType from "../../../global/Hooks/useDeviceType";
import useChartCustomerLogic from "./useChartCustomerLogic";
import TabChartFilter from "../components/TabChartFilter";
import Layout from "../components/Layout";
import BuutonFilter from "../components/BuutonFilter";
import SwitchButton from "../components/SwitchButton";
import RenderDatePicker from "../components/RenderDatePicker";
import { useDashboardSettings } from "../../../../Context/DashboardSettingProvider";
import TitleChart from "../components/TitleChart";
import useCheckDisplayChart from "../components/useCheckDisplayChart";
import { FilterIcon } from "lucide-react";
import CustomerBarChart from "./ChartRenderer";
import { useGetCustomerReceivedFileTypeDropdown } from "../Hook";
import FilterHandler from "../components/FilterHandler";
function CustomerChart() {
  const theme = useTheme().palette.mode;
  const { action, data } = useChartCustomerLogic();
  const {
    countState,
    orderType,
    activeFilterType,
    chartFilter,
    setReceivedFileTypeId,
  } = data;
  const { changeActiveFilterType, tabHandler } = action;
  const { data: getCustomerReceived } =
    useGetCustomerReceivedFileTypeDropdown();
  const deviceType = useDeviceType();
  /* -------------------------------- Accrdion -------------------------------- */
  const chartKey = "customerChart";
  const { displayChart } = useCheckDisplayChart(chartKey);
  const [filter, setFilter] = useState(false);
  const [value, setValue] = useState("");
  const [selectedValue, setSelectedValue] = useState("");
  return (
    <Layout>
      {displayChart ? (
        <>
          <Box
            sx={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              gap: 2,
              marginBottom: "4px",
              flexWrap: "nowrap",
              overflowX: "auto",
            }}
          >
            <Box
              sx={{
                display: "flex",
                width: "100%",
                padding: "0.5rem",
                flexWrap: "wrap",
              }}
            >
              <BuutonFilter
                changeActiveFilterType={changeActiveFilterType}
                label={"تعداد تولیدشده"}
                type={1}
                activeFilterType={activeFilterType}
              />
              <BuutonFilter
                changeActiveFilterType={changeActiveFilterType}
                label={"مساحت تولیدشده"}
                type={2}
                activeFilterType={activeFilterType}
              />
              <BuutonFilter
                changeActiveFilterType={changeActiveFilterType}
                label={"تعداد ثبت شده"}
                type={3}
                activeFilterType={activeFilterType}
              />
            </Box>
            <Box
              sx={{
                flexGrow: 1,
                width: "100%",
                display: "flex",
                justifyContent: "center",
                minWidth: 200,
              }}
            >
              <TitleChart label={"مشتریان برتر"} chartKey={chartKey} />
            </Box>
            <Box
              sx={{
                display: "inline-flex",
                alignItems: "center",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginLeft: "auto",
                  marginRight: "8px",
                }}
              >
                <TabChartFilter
                  chartFilter={chartFilter}
                  tabHandler={tabHandler}
                  name={"Customer"}
                />
              </Box>
              <FilterHandler filter={filter} setFilter={setFilter} />
            </Box>
          </Box>
          {filter && (
            <Fade in={filter} timeout={300}>
              <Box
                sx={{
                  display: "flex",
                  marginTop: "12px",
                  marginBottom: "8px",
                  padding: "8px",
                  backgroundColor: theme == "light" ? "#E6F1FF" : "#161B25",
                }}
              >
                <RenderDatePicker
                  chartFilter={chartFilter}
                  datePicker={data.datePicker}
                  setDatePicker={action.setDatePicker}
                />
                <FormControl
                  size="small"
                  sx={{ minWidth: 200, marginLeft: "8px" }}
                >
                  <Autocomplete
                    size="small"
                    options={getCustomerReceived?.data?.data || []}
                    getOptionLabel={(option) => option.key || ""}
                    value={
                      getCustomerReceived?.data?.data?.find(
                        (item) => item.key === selectedValue,
                      ) || null
                    }
                    onChange={(event, newValue) => {
                      if (newValue) {
                        setReceivedFileTypeId(newValue.value);
                        setSelectedValue(newValue.key);
                      } else {
                        setReceivedFileTypeId(null);
                        setSelectedValue("");
                      }
                    }}
                    renderInput={(params) => (
                      <TextField {...params} label="خروجی مستقیم" />
                    )}
                  />
                </FormControl>
              </Box>
            </Fade>
          )}

          <CustomerBarChart data={countState} type={activeFilterType} />

          <Box
            display={"flex"}
            flexWrap={{ xs: "wrap", md: "nowrap" }}
            margin={{ xs: 0.5, lg: 1 }}
            width={"100%"}
          >
            <Box
              sx={{
                display: "flex",
                padding: { xs: "0.5rem 0", md: "0" },
                flexWrap: "wrap",
                justifyContent: { xs: "space-between", md: "center" },
                width: "100%",
                alignItems: { xs: "start", md: "center" },
              }}
            >
              {deviceType != "mobile" && <TotalChart total={orderType} />}
            </Box>
          </Box>
        </>
      ):  <Box
              sx={{
                flexGrow: 1,
                width: "100%",
                display: "flex",
                justifyContent: "center",
                minWidth: 200,
              }}
            >
              <TitleChart label={"مشتریان برتر"} chartKey={chartKey} />
            </Box>}
    </Layout>
  );
}

export default CustomerChart;
